import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { BizzCustomersService } from '../../_services/bizz-customers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { MenuItem } from 'primeng/api';
import { BusinessSetupModel, SubscriptionModel } from 'src/app/_models/subscription-management/subscription-model';
import { PlanInfo } from 'src/app/_models/subscription-management/user-subscription-info';
import { Plan } from 'src/app/_models/subscription-plan/plan';

import { GlobalService } from 'src/app/_services/global.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';

@Component({
    selector: 'app-bizz-customer-detail',
    templateUrl: './bizz-customer-detail.component.html',
    styleUrls: ['./bizz-customer-detail.component.scss']
})
export class BizzCustomerDetailComponent implements OnInit {

    items: MenuItem[];


    activeItem: MenuItem;
    _globals = GlobalService;
    planInfo = <any>{};
    businessSetup = <BusinessSetupModel>{}
    dayLeftInRenewal: number = 0;

    isSubscriptionDetailsLoading: boolean = false;

    constructor(
        public _bizzCustomerService: BizzCustomersService,
        private _router: Router,
        private _abd: AppBaseDataService,
        private route: ActivatedRoute,
        private _connMessageService: ConnMessageService
    ) { }

    currentCustomer: any
    ngOnInit(): void {

        this.items = [
            { label: 'Subscription', visible: true },
            { label: 'Plan Configuration', visible: true },
            { label: 'Billing History', visible: false }, // hidden for the time being
            { label: 'Hardware' , visible: true },
        ];

        this.getCustomerDetails();
    }

    getCustomerDetails() {
        this.isSubscriptionDetailsLoading = true;
        this._abd.showSpinner();
        const businessId = this.route.snapshot.paramMap.get('businessId');
        const userId = this.route.snapshot.paramMap.get('userId');

        const today = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const parameters = {
            ReportName: 'adminaccountdetail',
            ReportParameters: [
                { Key: 'BusinessId', Value: businessId },
                { Key: 'UserId', Value: userId },
                { Key: 'CurrentDate', Value: today },
                { Key: 'TimeZone', Value: timeZone },
            ],
        };

        this._bizzCustomerService
            .getCustomerDetail(parameters)
            .subscribe((res) => {
                const payload = this.extractCustomerDetailPayload(res);
                const normalizedPayload = this.normalizeCustomerDetailData(payload);
                const hasRenderablePayload = this.hasRenderableCustomerPayload(normalizedPayload);
                const isTransportSuccess = res?.success === true || Number(res?.responseStatusCode) === 903;

                if (isTransportSuccess || hasRenderablePayload) {
                    this._bizzCustomerService.activeItem = normalizedPayload;
                    this.currentCustomer = this._bizzCustomerService.activeItem;
                    if (this.currentCustomer.isFreeTrial) {
                        const hasHardware = Array.isArray(this.currentCustomer.hardwarePkg) && this.currentCustomer.hardwarePkg.length > 0;
                        this.items
                            .filter(f => f.label != 'Subscription' && f.label != 'Plan Configuration' && !(f.label == 'Hardware' && hasHardware))
                            .map(f => f.visible = false);
                    }

                    this.getData();
                    this._abd.hideSpinner();
                    this.isSubscriptionDetailsLoading = false;
                    return;
                } else {
                    this._connMessageService.showToastMessage(
                        `There is no subscription available yet for acount`,
                        'error'
                    );
                }
                 this._abd.hideSpinner();
                 this.isSubscriptionDetailsLoading = false;
            });


    }


                private hasRenderableCustomerPayload(payload: any): boolean {
                    if (!payload || typeof payload !== 'object') {
                        return false;
                    }

                    const checks = [
                        payload?.firstName,
                        payload?.lastName,
                        payload?.email,
                        payload?.businessName,
                        payload?.businessPhone,
                        payload?.accountID,
                        payload?.businessId,
                        payload?.createdDate,
                        payload?.currentSubscription?.businessId,
                        payload?.currentSubscription?.userId,
                        payload?.currentSubscription?.planName,
                    ];

                    return checks.some((value) => String(value ?? '').trim().length > 0);
                }

    private extractCustomerDetailPayload(res: any): any {
        const parseJsonObject = (value: any): any => {
            if (typeof value !== 'string') {
                return value;
            }

            const trimmed = value.trim();
            if (!trimmed || (!trimmed.startsWith('{') && !trimmed.startsWith('['))) {
                return value;
            }

            try {
                return JSON.parse(trimmed);
            } catch {
                return value;
            }
        };

        const hasCustomerKeys = (value: any): boolean => {
            if (!value || typeof value !== 'object') {
                return false;
            }

            const keys = [
                'firstName',
                'lastName',
                'businessName',
                'companyName',
                'email',
                'businessEmail',
                'businessPhone',
                'phone',
                'accountID',
                'currentSubscription',
                'isFreeTrial',
            ];

            return keys.some((k) => value[k] !== undefined && value[k] !== null);
        };

        const hasValue = (value: any): boolean => {
            if (value === null || value === undefined) {
                return false;
            }

            if (typeof value === 'string') {
                return value.trim().length > 0;
            }

            return true;
        };

        const scoreCandidate = (value: any): number => {
            if (!value || typeof value !== 'object') {
                return 0;
            }

            let score = 0;
            if (hasValue(value?.firstName) || hasValue(value?.FirstName)) score += 5;
            if (hasValue(value?.lastName) || hasValue(value?.LastName)) score += 5;
            if (hasValue(value?.email) || hasValue(value?.Email) || hasValue(value?.businessEmail)) score += 5;
            if (hasValue(value?.businessName) || hasValue(value?.companyName)) score += 4;
            if (hasValue(value?.businessPhone) || hasValue(value?.phone) || hasValue(value?.contactNumber)) score += 3;
            if (hasValue(value?.accountID) || hasValue(value?.businessId)) score += 2;
            if (value?.currentSubscription && typeof value.currentSubscription === 'object') score += 2;
            if (hasValue(value?.businessNameWithDomain)) score += 1;
            if (hasValue(value?.createdDate)) score += 1;
            return score;
        };

        const visited = new Set<any>();
        const collected: any[] = [];
        const deepCollect = (node: any, depth = 0): void => {
            node = parseJsonObject(node);

            if (!node || typeof node !== 'object' || visited.has(node) || depth > 6) {
                return;
            }

            visited.add(node);

            if (Array.isArray(node)) {
                for (const item of node) {
                    deepCollect(item, depth + 1);
                }
                return;
            }

            if (hasCustomerKeys(node)) {
                collected.push(node);
            }

            for (const value of Object.values(node)) {
                deepCollect(value, depth + 1);
            }
        };

        const directCandidates: any[] = [
            res?.data,
            res?.data?.[0],
            res?.data?.data,
            res?.data?.data?.[0],
            res?.data?.result,
            res?.data?.result?.[0],
            res?.result,
            res?.result?.[0],
            res?.payload,
            res?.payload?.data,
            res?.payload?.data?.[0],
            res,
        ];

        for (const candidate of directCandidates) {
            deepCollect(candidate);
        }

        if (collected.length > 0) {
            const best = [...collected].sort((a, b) => scoreCandidate(b) - scoreCandidate(a))[0];
            if (best) {
                return best;
            }
        }

        const fallback: any = {};
        const assignIfEmpty = (key: string, value: any): void => {
            const current = fallback?.[key];
            if (String(current ?? '').trim().length < 1 && String(value ?? '').trim().length > 0) {
                fallback[key] = value;
            }
        };

        const scanForKnownFields = (node: any, depth = 0): void => {
            node = parseJsonObject(node);
            if (!node || depth > 7) {
                return;
            }

            if (Array.isArray(node)) {
                for (const item of node) {
                    scanForKnownFields(item, depth + 1);
                }
                return;
            }

            if (typeof node !== 'object') {
                return;
            }

            for (const [rawKey, rawValue] of Object.entries(node)) {
                const key = String(rawKey || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                const value: any = parseJsonObject(rawValue);

                if (key === 'firstname') assignIfEmpty('firstName', value);
                else if (key === 'lastname') assignIfEmpty('lastName', value);
                else if (key === 'email') assignIfEmpty('email', value);
                else if (key === 'businessemail') assignIfEmpty('businessEmail', value);
                else if (key === 'businessname') assignIfEmpty('businessName', value);
                else if (key === 'businessdisplayname') assignIfEmpty('businessDisplayName', value);
                else if (key === 'companyname') assignIfEmpty('companyName', value);
                else if (key === 'businessphone') assignIfEmpty('businessPhone', value);
                else if (key === 'phone' || key === 'contactnumber') assignIfEmpty('phone', value);
                else if (key === 'nooflocations' || key === 'numberoflocations' || key === 'locationcount') assignIfEmpty('noOfLocations', value);
                else if (key === 'createddate') assignIfEmpty('createdDate', value);
                else if (key === 'accountid') assignIfEmpty('accountID', value);
                else if (key === 'businessid') assignIfEmpty('businessId', value);
                else if (key === 'userid') assignIfEmpty('userId', value);
                else if (key === 'accountstatusdisplay') assignIfEmpty('accountStatusDisplay', value);
                else if (key === 'accountstatusstring') assignIfEmpty('accountStatusString', value);
                else if (key === 'isfreetrial') {
                    if (fallback.isFreeTrial === undefined || fallback.isFreeTrial === null) {
                        fallback.isFreeTrial = value;
                    }
                } else if (key === 'currentsubscription' && value && typeof value === 'object') {
                    fallback.currentSubscription = value;
                }

                if (value && typeof value === 'object') {
                    scanForKnownFields(value, depth + 1);
                }
            }
        };

        for (const candidate of directCandidates) {
            scanForKnownFields(candidate);
        }

        if (Object.keys(fallback).length > 0) {
            return fallback;
        }

        return parseJsonObject(res?.data) ?? parseJsonObject(res) ?? {};
    }

    private normalizeCustomerDetailData(data: any): any {
        let source: any = data || {};
        if (typeof source === 'string') {
            try {
                source = JSON.parse(source);
            } catch {
                source = {};
            }
        }

        if (!source || typeof source !== 'object') {
            source = {};
        }

        const looksLikeSubscriptionOnly =
            !!source?.planId
            && !source?.currentSubscription
            && source?.businessNameWithDomain;
        const currentSubscription = looksLikeSubscriptionOnly
            ? source
            : (source.currentSubscription || {});
        const normalizedBusinessNameWithDomain = String(
            currentSubscription?.businessNameWithDomain || source?.businessNameWithDomain || ''
        ).trim();
        const normalizedBusinessName = normalizedBusinessNameWithDomain
            ? normalizedBusinessNameWithDomain.replace(/lincsell$/i, '').trim()
            : '';
        const statusStringRaw = String(source?.accountStatusString || '').trim().toLowerCase();
        const apiDisplayRaw = String(source?.accountStatusDisplay ?? source?.AccountStatusDisplay ?? '').trim();
        const numericStatus = Number(source?.accountStatus);
        const resolvedStatusDisplay =
            statusStringRaw.includes('deactivated')
                ? 'Deactivated'
                : (statusStringRaw.includes('expired') || numericStatus === 4)
                    ? 'Inactive'
                    : String(apiDisplayRaw || '').trim().length > 0
                        ? apiDisplayRaw
                        : (statusStringRaw.includes('inactive')
                            ? 'Inactive'
                            : (source?.accountStatusString || 'Active'));

        const normalized = {
            ...source,
            currentSubscription,
            businessId: source.businessId ?? source.accountID ?? currentSubscription.businessId ?? null,
            userId: source.userId ?? currentSubscription.userId ?? null,
            firstName: String(source.firstName ?? source.FirstName ?? '').trim(),
            lastName: String(source.lastName ?? source.LastName ?? '').trim(),
            email: String(source.email ?? source.businessEmail ?? source.Email ?? '').trim(),
            businessName: String(
                source.businessDisplayName
                ?? source.BusinessDisplayName
                ?? source.businessName
                ?? source.companyName
                ?? normalizedBusinessName
                ?? normalizedBusinessNameWithDomain
                ?? ''
            ).trim(),
            businessPhone: String(source.businessPhone ?? source.phone ?? source.contactNumber ?? '').trim(),
            noOfLocations: source.noOfLocations ?? source.numberOfLocations ?? source.locationCount ?? 0,
            createdDate: source.createdDate ?? currentSubscription.createdDate ?? null,
            accountStatusDisplay: resolvedStatusDisplay,
            isFreeTrial: !!source.isFreeTrial,
        };

        if (!normalized.firstName && String(source?.companyName ?? '').trim().length > 0) {
            normalized.firstName = String(source.companyName).trim();
        }

        if (!normalized.businessName && String(source?.companyName ?? '').trim().length > 0) {
            normalized.businessName = String(source.companyName).trim();
        }

        return normalized;
    }



    getData() {
        this._abd.showSpinner()
        try {
            this.activeItem = this.items[0];
            this.businessSetup = this._globals.userInfo.businessSetup[0];
            this.planInfo = this.currentCustomer;

            if (this.planInfo.isFreeTrial) {
                const startRaw = this.planInfo?.freeTrialStartDate ?? this.planInfo?.trialStartDate ?? null;
                const endRaw = this.planInfo?.freeTrialEndDate ?? this.planInfo?.trialEndDate ?? null;

                if (startRaw && endRaw) {
                    const startDate = new Date(startRaw);
                    const endDate = new Date(endRaw);

                    if (!Number.isNaN(startDate.getTime()) && !Number.isNaN(endDate.getTime())) {
                        const diff = Math.abs(endDate.getTime() - startDate.getTime());
                        this.dayLeftInRenewal = Math.ceil(diff / (1000 * 3600 * 24));
                    } else {
                        this.dayLeftInRenewal = 0;
                    }
                } else {
                    this.dayLeftInRenewal = 0;
                }
            }

        }
        catch {

        }
        finally {
            this._abd.hideSpinner()
        }

    }
    onTabItemClick(tab: any) {
        if (tab?.activeItem) {
            this.activeItem = tab.activeItem
            return
        }

        if (!this.activeItem && this.items?.length) {
            this.activeItem = this.items[0]
        }
    }


}
